import React from "react";

const WorkAnniversary = ({ employees = [] }) => {
  return (
    <div className="card anniversary-card">
      {/* HEADER */}
     
<div className="card-header birthday-snow-header">
        <h5 className="card-title mb-0">🎉 Work Anniversaries Today</h5>
      </div>

      {/* 👇 MANUAL SCROLL */}
      <div className="card-body p-2 birthday-scroll-manual">
  {employees.length === 0 ? (
    <div className="text-muted text-center py-3">
      No work anniversaries today 🎈
    </div>
  ) : (
    employees.map((emp, index) => (
      <div className="anniversary-row d-flex align-items-center justify-content-between" key={index}>

        {/* LEFT: Avatar + Info */}
        <div className="d-flex align-items-center gap-2">
          {/* Avatar */}
          <div className="anniversary-avatar">
            {emp.employee_name
              .split(" ")
              .map(n => n[0])
              .join("")
              .slice(0, 2)
              .toUpperCase()}
          </div>

          {/* Info */}
          <div className="anniversary-info">
            <div className="anniversary-name">
              {emp.employee_name}
            </div>

            <div className="anniversary-department">
              {emp.department_name}
            </div>
          </div>
        </div>

        {/* RIGHT: Years Completed */}
        <span className="badge bg-success">
          {emp.years_completed} Years Completed
        </span>
      </div>
    ))
  )}
</div>

    </div>
  );
};

export default WorkAnniversary;
